// Romantic letter message for the intro screen

export const LETTER_MESSAGE = `Hi Chinelo,

It's been over two years of us now, and we've come a long way. Even with our fights, I genuinely love being around you. I wouldn't trade you for the world, and I want you to know that I’m locked in with you forever.

I know past Valentines haven't gone as planned. Remember our first one, when I got you bread thinking it was chocolate? 😅 Or last year, when we didn't have a reservation and I showed up late because of traffic. Honestly, it was a mess.

I want to make it up to you this time. I want to replace that memory with something much better.

That’s why I built this little world for you.

I love you.

Will you be my Valentine? 🌹`;

export const NO_RESPONSE_MESSAGE = `That's completely okay! 💕

Thank you for being honest with me. Whatever your reason, I respect it fully.

I hope this brought a little smile to your face anyway. You deserve all the happiness in the world.

Take care of yourself always. 🌸`;

export const SHARE_MESSAGE = `Hey! Check out the Valentine's plan I just built! 💕`;
